export default {
    methods: {
        notifyError (message) {
            this.$notify({
                timeout: this.getTimeOut(message),
                message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                icon: 'error',
                type: 'danger'
            });
        },
        notifyWarning (message) {
            this.$notify({
                timeout: this.getTimeOut(message),
                message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                icon: 'warning',
                type: 'warning'
            });
        },

        notifySuccess (message) {
            this.$notify({
                timeout: this.getTimeOut(message),
                message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                icon: 'check_circle',
                type: 'success'
            });
        },

        notifyInfo (message) {
            this.$notify({
                timeout: this.getTimeOut(message),
                message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                icon: 'info',
                type: 'info'
            });
        },
        getTimeOut (message) {
            let length = 5;
            if (typeof message !== 'undefined') {
                length = message.split(' ').length;
            }
            if (length < 3) {
                return 3000;
            }
            if (length > 10) {
                return 10000;
            }
            return length * 1000;
        },

        notifyException (e) {
            console.log(e.response)
            let message = 'Oops! Something went wrong.';
            let status = null;
            let errors = null;

            if (e && e.response) {
                status = e.response.status;
                errors = e.response.data && e.response.data.errors ? e.response.data.errors : null;
            }

            if (Array.isArray(errors) && errors.length > 0) {
                message = errors[0].detail || errors[0].title || message;
            } else if (typeof errors === 'object' && errors !== null) {
                message = errors.title + ' ' + errors.detail;
            } else if (e && e.message) {
                message = e.message;
            }

            if (status === 400) {
                message += '. Bad request. Please check your input.';
            } else if (status === 401) {
                message += 'Unauthorized. Please log in.';
            } else if (status === 403) {
                message += '.You don’t have permission to do this.';
            } else if (status === 404) {
                message = 'Requested resource not found.';
            } else if (status === 422 && !message) {
                message += 'Validation failed. Please check the form.';
            } else if (status === 500) {
                message += 'Server error. Please try again later. Contact System adminstrator';
            }

            this.$notify({
                timeout: this.getTimeOut ? this.getTimeOut(message) : 4000,
                message: message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                icon: 'error',
                type: 'danger'
            });
        }

    }
};
